import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Building2 } from "lucide-react";
import BulkEnquiry from "@/components/BulkEnquiry";

const links = [
  { to: "/", label: "Home" },
  { to: "/games", label: "Games" },
  { to: "/leaderboard", label: "Leaderboard" },
  { to: "/challenge", label: "Challenge" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [bulk, setBulk] = useState(false);
  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <img src="/logo-er.png" alt="Escape Room Bengaluru" className="h-11 w-auto group-hover:scale-105 transition-transform" data-testid="nav-logo-img" />
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                pathname === l.to ? "text-[#F9CF04] bg-[#F9CF04]/10" : "text-slate-300 hover:text-white hover:bg-white/5"}`}>
              {l.label}
            </Link>
          ))}
          <button onClick={() => setBulk(true)} data-testid="nav-bulk"
            className="ml-1 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold bg-emerald-500/15 text-emerald-300 border border-emerald-500/30 hover:bg-emerald-500/25 transition-colors">
            <Building2 className="h-4 w-4" /> Corporate / Bulk
          </button>
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 px-5 py-3 space-y-1 glass">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block px-3 py-2 rounded-lg text-slate-200 hover:bg-white/5" data-testid={`mnav-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
          <button onClick={() => { setOpen(false); setBulk(true); }}
            className="block w-full text-left px-3 py-2 rounded-lg text-emerald-300 hover:bg-white/5" data-testid="mnav-bulk">
            Corporate / Bulk bookings
          </button>
        </div>
      )}
      <BulkEnquiry open={bulk} onOpenChange={setBulk} />
    </header>
  );
}
